import { useState, useEffect } from "react";
import { FormHelperText, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { PhoneNumberModel, PhoneNumberStatus } from "../../models/phone-number.model";
import { Autocomplete } from "@mui/material";
import { UtilityService } from "../../services/UtilityService";
import { CreditType, mapToPlanMetrics, PlanMetrics } from "../../models/plan-metrics.model";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TransferInProgressAnimationData from "../shared/loaders/transfers-progress-animation.json";
import TransferSuccessAnimationData from "../shared/loaders/transfers-success-animation.json";
import { PhoneNumberService } from "../../services/PhonenumberService";
import ConfirmDialog from "../shared/confirm-dialog.component";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, creditTypeTexts, ToasterTexts, validationsMessages } from "../shared/constants";
import setToast from "../../helpers/toaster.helper"
import { ToasterType } from "../shared/toaster/toaster.model";
import { LoadPhoneNumbersGridData } from "../../actions";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { InfoCircleIcon, NewInfoCircleIcon } from "../../icon";

interface Props {
    HandleNext: (x) => void;
    Stepdata: any
}

type CreditOption = {
    Type: string;
    Key: CreditType;
}

const creditOptions: CreditOption[] = [
    {
        Type: creditTypeTexts.PLAN_CREDITS_NORMAL,
        Key: CreditType.PLAN_CREDITS_NORMAL
    },
    {
        Type: creditTypeTexts.PLAN_CREDITS_GROUP,
        Key: CreditType.PLAN_CREDITS_GROUP
    },
    {
        Type: creditTypeTexts.ADDON_CREDITS_NORMAL,
        Key: CreditType.ADDON_CREDITS_NORMAL
    },
    {
        Type: creditTypeTexts.ADDON_CREDITS_GROUP,
        Key: CreditType.ADDON_CREDITS_GROUP
    }
]
const TransferFormComponent = (props: Props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const LoadingPhoneNumbers: boolean = useSelector(selector.loadingPhoneNumbers)
    const LoadedPhoneNumbers: boolean = useSelector(selector.loadedPhoneNumbers)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    let sessionData = JSON.parse(sessionStorage.getItem("transfers") || "{}");
    let sourcePhone = PhoneNumbers.find(x => x.ID === sessionData?.spid);
    let targetPhone = PhoneNumbers.find(x => x.ID === sessionData?.tpid);

    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showSuccessLoader, setShowSuccessLoader] = useState<boolean>(false)
    const [showConfiramtion, setShowConfiramtion] = useState<boolean>(false)
    const [sourcePhoneID, setSourcePhoneID] = useState<string>(sourcePhone?.ID || "")
    const [targetPhoneID, setTargetPhoneID] = useState(targetPhone?.ID || "")
    const [creditsToTransfer, setCreditsToTransfer] = useState<number>(sessionData?.credits || NaN)
    const [sorucePhonePlanTracker, setSorucePhonePlanTracker] = useState<PlanMetrics>()
    const [targetPhonePlanTracker, setTargetPhonePlanTracker] = useState<PlanMetrics>()
    const [creditTypeText, setCreditTypeText] = useState<string>("")
    const [sourcePhoneNumberName, setSourcePhoneNumberName] = useState<string>()
    const [targetPhoneNumberName, setTargetPhoneNumberName] = useState<string>()
    const [creditType, setCreditType] = useState<CreditType>(sessionData?.credittype || null)
    const [sourcePhoneNumber, setSourcePhoneNumber] = useState<string>(sourcePhone?.PhoneNumber || "")
    const [targetPhoneNumber, setTargetPhoneNumber] = useState<string>(targetPhone?.PhoneNumber || "")
    const [errors, setErrors] = useState<{
        SourcePhoneNumber?: string;
        TargetPhoneNumber?: string;
        CreditType?: string;
        CreditAmount?: string;
    }>({
        SourcePhoneNumber: sourcePhone?.PhoneNumber || "",
        TargetPhoneNumber: targetPhone?.PhoneNumber || "",
        CreditType: "",
        CreditAmount: "",
    })

    const handleSourcePhoneChange = (event: any, value: any) => {
        setSourcePhoneID(value?.ID || "")
        setSourcePhoneNumber(value?.PhoneNumber || "")
        setSourcePhoneNumberName(value?.Name || "")
        setSorucePhonePlanTracker(undefined)
        setTargetPhoneID(value?.ID === targetPhoneID ? "" : targetPhoneID)
        setTargetPhoneNumber(value?.ID === targetPhoneID ? "" : targetPhoneNumber)
        setTargetPhoneNumberName(value?.ID === targetPhoneID ? "" : targetPhoneNumberName)
        setTargetPhonePlanTracker(value?.ID === targetPhoneID ? undefined : targetPhonePlanTracker)



        let sourcePhnID = value?.ID || ""
        if (sourcePhnID === "") {
            setErrors({ ...errors, SourcePhoneNumber: validationsMessages.TRANSFER_CREDITS_FROM_REQUIRED })
            setCreditsToTransfer(NaN)
            setErrors({ ...errors, CreditAmount: "" })
        }
        else if (sourcePhoneID !== sourcePhnID) {
            setCreditsToTransfer(NaN)
            setErrors(prev => ({ ...prev, CreditAmount: "" }));
        }
        else {
            setErrors({ ...errors, SourcePhoneNumber: "" })
        }

        if (value?.ID) {
            PhoneNumberService.getPhonePlanTracker(value?.ID).then(res => {
                setSorucePhonePlanTracker(mapToPlanMetrics(res.data))
                const SorucePhnPlanTracker = mapToPlanMetrics(res.data)

                if (creditType === CreditType.ADDON_CREDITS_GROUP && SorucePhnPlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
                    setErrors({ ...errors, SourcePhoneNumber: "Sorry, you cannot share group credits from this Phone Number" });
                }
                else if (creditType === CreditType.ADDON_CREDITS_NORMAL && SorucePhnPlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
                    setErrors({ ...errors, SourcePhoneNumber: "Sorry, You cannot share 1-1 addon credits from this Phone Number" });
                }
                else {
                    setErrors(prev => ({ ...prev, SourcePhoneNumber: "" }))
                }
            })
        }
    }

    const handleTargetPhoneChange = (event: any, value: any) => {
        let TargetPhnID = value?.ID || ""
        setTargetPhoneID(value?.ID || "")
        setTargetPhoneNumber(value?.PhoneNumber || "")
        setTargetPhoneNumberName(value?.Name || "")
        setTargetPhonePlanTracker(undefined)

        if (TargetPhnID === "") {
            setErrors({ ...errors, TargetPhoneNumber: validationsMessages.TRANSFER_CREDITS_TO_REQUIRED })
        }
        else {
            setErrors({ ...errors, TargetPhoneNumber: "" })
        }
        if (value?.ID) {
            PhoneNumberService.getPhonePlanTracker(value?.ID).then(res => {
                setTargetPhonePlanTracker(mapToPlanMetrics(res.data))
                const TargetPhnPlanTracker = mapToPlanMetrics(res.data)

                if (creditType === CreditType.ADDON_CREDITS_GROUP && TargetPhnPlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
                    setErrors({ ...errors, TargetPhoneNumber: "Sorry, you cannot share group credits to this Phone Number" });
                }
                else if (creditType === CreditType.ADDON_CREDITS_NORMAL && TargetPhnPlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
                    setErrors({ ...errors, TargetPhoneNumber: "Sorry, You cannot share 1-1 addon credits to this Phone Number" });
                }
                else {
                    setErrors({ ...errors, TargetPhoneNumber: "" })
                }
            })
        }
    }
    const handleCreditTypeChange = (event: any, value: any) => {

        const type = value?.Key
        setCreditType(value?.Key || "")
        setCreditTypeText(value?.Type || "")
        setCreditsToTransfer(NaN)
        setErrors({ ...errors, CreditAmount: "" })

        let SourcePhoneNumber = ""
        let TargetPhoneNumber = ""

        if (!type) {
            setErrors({ ...errors, CreditType: validationsMessages.TRANSFER_CREDITS_TYPE_REQUIRED })
        }
        else if (type === CreditType.ADDON_CREDITS_GROUP && sorucePhonePlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
            SourcePhoneNumber = "Sorry, you cannot share group credits from this Phone Number"
        }
        else if (type === CreditType.ADDON_CREDITS_NORMAL && sorucePhonePlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
            SourcePhoneNumber = "Sorry, You cannot share 1-1 addon credits from this Phone Number"
        }

        if (type === CreditType.ADDON_CREDITS_GROUP && targetPhonePlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
            TargetPhoneNumber = "Sorry, you cannot share group credits to this Phone Number"
        }
        else if (type === CreditType.ADDON_CREDITS_NORMAL && targetPhonePlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
            TargetPhoneNumber = "Sorry, You cannot share 1-1 addon credits to this Phone Number"
        }
        setErrors({ ...errors, SourcePhoneNumber, TargetPhoneNumber, CreditType: "" })
    }

    const handleCreditsToTransferChange = (event: any) => {
        const creditsTransfer = event.target.value
        setCreditsToTransfer(event.target.value || NaN)

        if (creditsTransfer !== 0 && !creditsTransfer) {

            setErrors({ ...errors, CreditAmount: validationsMessages.TRANSFER_CREDITS_AMOUNT_REQUIRED })
        }
        else if (creditsTransfer == 0) {
            setErrors({ ...errors, CreditAmount: validationsMessages.TRANSFER_CREDITS_AMOUNT_INVALID })
        }
        else if (sorucePhonePlanTracker && creditsTransfer > getSelectedCreditTypeCount(sorucePhonePlanTracker)) {
            setErrors({ ...errors, CreditAmount: validationsMessages.TRANSFER_CREDITS_INSUFFICIENT })
        }
        else {
            setErrors({ ...errors, CreditAmount: "" })
        }
    }
    const validateForm = () => {
        let formValid = true;
        const newErrors = { ...errors };
        if (sourcePhoneID === "") {
            newErrors.SourcePhoneNumber = validationsMessages.TRANSFER_CREDITS_FROM_REQUIRED;
            formValid = false;
        }
        if (targetPhoneID === "") {
            newErrors.TargetPhoneNumber = validationsMessages.TRANSFER_CREDITS_TO_REQUIRED;
            formValid = false;
        }
        if (!creditType) {
            newErrors.CreditType = validationsMessages.TRANSFER_CREDITS_TYPE_REQUIRED;
            formValid = false;
        }
        if (creditsToTransfer !== 0 && !creditsToTransfer) {
            newErrors.CreditAmount = validationsMessages.TRANSFER_CREDITS_AMOUNT_REQUIRED;
            formValid = false;
        }
        if (creditType === CreditType.ADDON_CREDITS_GROUP && sorucePhonePlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
            newErrors.SourcePhoneNumber = "Sorry, you cannot share group credits from this Phone Number";
            formValid = false;
        }
        if (creditType === CreditType.ADDON_CREDITS_NORMAL && sorucePhonePlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
            newErrors.SourcePhoneNumber = "Sorry, You cannot share 1-1 addon credits from this Phone Number";
            formValid = false;
        }
        if (creditType === CreditType.ADDON_CREDITS_GROUP && targetPhonePlanTracker?.GroupCreditsUsage?.PlanCredits === -1) {
            newErrors.TargetPhoneNumber = "Sorry, you cannot share group credits to this Phone Number";
            formValid = false;
        }
        if (creditType === CreditType.ADDON_CREDITS_NORMAL && targetPhonePlanTracker?.NormalTextingUsage?.PlanCredits === -1) {
            newErrors.TargetPhoneNumber = "Sorry, You cannot share 1-1 addon credits to thisPhone Number";
            formValid = false;
        }
        if (creditsToTransfer == 0) {
            newErrors.CreditAmount = validationsMessages.TRANSFER_CREDITS_AMOUNT_INVALID;
            formValid = false;
        }
        if (sorucePhonePlanTracker && creditsToTransfer > getSelectedCreditTypeCount(sorucePhonePlanTracker)) {
            newErrors.CreditAmount = validationsMessages.TRANSFER_CREDITS_INSUFFICIENT;
            formValid = false;
        }
        setErrors(newErrors);
        return formValid;
    }
    useEffect(() => {
        if (!LoadingPhoneNumbers && PhoneNumbers.length === 0 && !LoadedPhoneNumbers) {
            LoadPhoneNumbersGridData(dispatch);
        }
        if (!!sourcePhoneID) {
            PhoneNumberService.getPhonePlanTracker(sourcePhoneID).then(res => {
                setSorucePhonePlanTracker(mapToPlanMetrics(res.data))
            })
        }
        if (!!targetPhoneID) {
            PhoneNumberService.getPhonePlanTracker(targetPhoneID).then(res => {
                setTargetPhonePlanTracker(mapToPlanMetrics(res.data))
            })
        }
    }, [])

    const handleTransfer = () => {

        if (!validateForm()) {
            return;
        }
        setShowLoader(true)
        PhoneNumberService.transferCredits(sourcePhoneID, targetPhoneID, creditType, creditsToTransfer)
            .then(res => {
                setShowLoader(false)
                setShowConfiramtion(false)
                setShowSuccessLoader(true)

                setTimeout(() => {
                    setShowSuccessLoader(false)
                    props.HandleNext({
                        SourcePhoneNumber: sourcePhoneNumber,
                        TargetPhoneNumber: targetPhoneNumber,
                        SourcePhoneNumberName: sourcePhoneNumberName,
                        TargetPhoneNumberName: targetPhoneNumberName,
                        CreditTypeText: creditTypeText,
                        CreditsToTransfer: creditsToTransfer
                    })
                }, 100);
            })
            .catch(error => {
                if (error.response.data.code === "TO-NOT-ACTIVE") {
                    setShowLoader(false)
                    setShowConfiramtion(false)
                    setToast(ToasterTexts.TRANSFER_FAILED_TO_NUMBER_NOT_ACTIVE.replace("<TO_PHONE_NAME>", `${UtilityService.maskPhoneNumberOnLength(errors.TargetPhoneNumber)} (${targetPhoneNumberName})`), ToasterType.DANGER)
                }
                else {
                    setShowLoader(false)
                    setShowConfiramtion(false)
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                }
            })
    }
    const openConfirmation = (event: any) => {
        event.preventDefault();
        if (!validateForm()) {
            return;
        }
        setShowConfiramtion(true);
    }
    const closeConfirmDialog = (isConfim: boolean) => {
        if (isConfim) {
            handleTransfer()
        }
        else {
            setShowConfiramtion(false)
        }
    }
    const getSelectedCreditTypeCount = (plantracker?: PlanMetrics) => {
        var PlanGroupCredits = plantracker.GroupCreditsUsage.PlanCredits >= 0 ? plantracker.GroupCreditsUsage.PlanCredits - plantracker.GroupCreditsUsage.UsedCredits : plantracker.GroupCreditsUsage.PlanCredits;
        var PlanNormalCredits = plantracker.NormalTextingUsage.PlanCredits >= 0 ? plantracker.NormalTextingUsage.PlanCredits - plantracker.NormalTextingUsage.UsedCredits : plantracker.NormalTextingUsage.PlanCredits;
        var AddonGroupCredits = plantracker.GroupCreditsUsage.AddOnCredits === 0 ? 0 : (plantracker.GroupCreditsUsage.PlanCredits - plantracker.GroupCreditsUsage.UsedCredits) < 0 ? plantracker.GroupCreditsUsage.AddOnCredits + (plantracker.GroupCreditsUsage.PlanCredits - plantracker.GroupCreditsUsage.UsedCredits) : plantracker.GroupCreditsUsage.AddOnCredits;
        var AddonNormalCredits = plantracker.NormalTextingUsage.AddOnCredits === 0 ? 0 : (plantracker.NormalTextingUsage.PlanCredits - plantracker.NormalTextingUsage.UsedCredits) < 0 ? plantracker.NormalTextingUsage.AddOnCredits + (plantracker.NormalTextingUsage.PlanCredits - plantracker.NormalTextingUsage.UsedCredits) : plantracker.NormalTextingUsage.AddOnCredits;
        return (creditType === CreditType.ADDON_CREDITS_GROUP ? AddonGroupCredits :
            creditType === CreditType.ADDON_CREDITS_NORMAL ? AddonNormalCredits :
                creditType === CreditType.PLAN_CREDITS_GROUP ? PlanGroupCredits :
                    PlanNormalCredits) || 0;
    }
    const handleClear = () => {
        setSourcePhoneID("")
        setTargetPhoneID("")
        setCreditsToTransfer(NaN)
        setCreditTypeText("")
        setCreditType(null)

        setErrors({
            SourcePhoneNumber: sourcePhone?.PhoneNumber || "",
            TargetPhoneNumber: targetPhone?.PhoneNumber || "",
            CreditType: "",
            CreditAmount: "",
        })

    }
    return (
        <>
            {
                showLoader && !showSuccessLoader &&
                <div style={{ zIndex: 10000 }} className="p-absolute t-0 l-0 w-fill h-v-100 bg-color-loader-backdrop">
                    <div className="w-16 p-absolute l-p-50 t-p-50 pa-center">
                        <AnimateLoader LoaderAnimation={TransferInProgressAnimationData} className="w-16"></AnimateLoader>
                    </div>
                </div>
            }
            {
                showSuccessLoader && !showLoader &&
                <div style={{ zIndex: 10000 }} className="p-absolute t-0 l-0 w-fill h-v-100 bg-color-loader-backdrop">
                    <div className="w-16 p-absolute l-p-50 t-p-50 pa-center">
                        <AnimateLoader LoaderAnimation={TransferSuccessAnimationData} className="w-16"></AnimateLoader>
                    </div>
                </div>
            }
            <>
                {!IsMobileDevice && <Grid container className={` h-p-95 m-auto`}>
                    <form onSubmit={openConfirmation} className={`w-fill d-flex flex-direction`}>
                        <div className={`w-p-65 settings-paper-border br-2 m-auto ${IsDarkMode ? "bg-color-sidebar-bg" : "paper-background"} my-8`}>
                            <div className={`bg-color-groupchat-avator-icon-bg`}>
                                <div className='d-flex align-center pt-3' >
                                    <div className={`d-flex ml-4`} style={{ flex: 1 }}>
                                        <Typography className={`h3-semibold ${IsDarkMode ? "color-lite-dark-black" : "color-settings-heading"}`}>
                                            {appNote.MANUAL_CREDIT_TRANSFER}
                                        </Typography>
                                    </div>
                                </div>
                                <div className={`report-text  pb-2 pt-1 px-4 ${IsDarkMode ? "color-lite-dark-black" : "color-conv-section-inactive"}`} >
                                    <div>Manually transfer credits between phone numbers as needed. Select the source, recipients, and the amount of credits to transfer.</div>
                                </div>
                            </div>
                            <div className="border-top"></div>
                            <div className='d-flex align-center' style={{ gap: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pr-1 pl-4 pt-2'>Source Phone Number</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip title={"Enter the phone number from which credits will be transferred."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 pl-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers.filter(x => x.ID !== targetPhoneID && (x.Status === PhoneNumberStatus.ACTIVE)) || []}
                                        getOptionLabel={(option: PhoneNumberModel) => option.PhoneNumber ? `${UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} (${option.Name})` : ""}
                                        onChange={handleSourcePhoneChange}
                                        value={PhoneNumbers.find((x: PhoneNumberModel) => x.ID === sourcePhoneID) || { PhoneNumber: "", Name: "" } as PhoneNumberModel}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular  lite-dark-black p-1 d-flex justify-between w-p-90"}>
                                                <div> {UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} ({option.Name})</div></li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="from" size="small" variant="outlined" placeholder="From *" />}
                                    />
                                    <div className="min-h-5">
                                        {!!creditType && sorucePhonePlanTracker && (
                                            <FormHelperText className="h6-regular color-toaster-font t-align-right">
                                                {appNote.AVAILABLE} {creditTypeText} -{" "}
                                                <span className="h6-bold color-primary-light">{getSelectedCreditTypeCount(sorucePhonePlanTracker)}</span>
                                            </FormHelperText>
                                        )}
                                        {errors?.SourcePhoneNumber && (
                                            <FormHelperText className="h5 color-primary-danger t-align-right">
                                                {errors?.SourcePhoneNumber}
                                            </FormHelperText>
                                        )}
                                    </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pl-2 pr-1 pt-2'>Recipient Phone Numbers</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip title={"Enter one or more phone numbers to receive credits."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 px-2 pr-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers.filter(x => x.ID !== sourcePhoneID && (x.Status === PhoneNumberStatus.ACTIVE)) || []}
                                        getOptionLabel={(option: PhoneNumberModel) => option.PhoneNumber ? `${UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} (${option.Name})` : ""}
                                        onChange={handleTargetPhoneChange}
                                        value={PhoneNumbers.find((x: PhoneNumberModel) => x.ID === targetPhoneID) || { PhoneNumber: "", Name: "" } as PhoneNumberModel}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular lite-dark-black p-1 d-flex justify-between w-p-90"}>
                                                <div> {UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} ({option.Name})</div></li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="to" size="small" variant="outlined" placeholder="To *" />}
                                    />
                                    <div className="min-h-5">
                                        {!!creditType && targetPhonePlanTracker && (
                                            <FormHelperText className="h6-regular color-toaster-font t-align-right mr-4">
                                                {appNote.AVAILABLE} {creditTypeText} -{" "}
                                                <span className="h6-bold color-primary-light">{getSelectedCreditTypeCount(targetPhonePlanTracker)}</span>
                                            </FormHelperText>
                                        )}
                                        {errors?.TargetPhoneNumber && (
                                            <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                                {errors?.TargetPhoneNumber}
                                            </FormHelperText>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex align-center' style={{ gap: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pr-1 pl-4 pt-2'>Credit Type</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip title={"Specify the type of credits to transfer."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 pl-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={creditOptions.filter((x: CreditOption) => x.Key === CreditType.ADDON_CREDITS_GROUP || x.Key === CreditType.ADDON_CREDITS_NORMAL)}
                                        getOptionLabel={(option: CreditOption) => option.Type}
                                        onChange={handleCreditTypeChange}
                                        value={creditOptions.find((x: CreditOption) => x.Key === creditType) || null}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular lite-dark-black p-1 d-flex justify-between w-p-90"}>
                                                <div> {option.Type}</div>
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="type" size="small" variant="outlined" placeholder="Credit Type *" />}
                                    />
                                    <div className="min-h-3">
                                        {errors?.CreditType && (
                                            <FormHelperText className="h5 color-primary-danger t-align-right">
                                                {errors?.CreditType}
                                            </FormHelperText>
                                        )}
                                    </div>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pl-2 pr-1 pt-2'>Credit Amount</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip title={"Specify the number of credits to transfer."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <TextField
                                        fullWidth
                                        name="CreditsToTransfer"
                                        placeholder="Credit Amount *"
                                        size="small"
                                        type="number"
                                        variant="outlined"
                                        value={creditsToTransfer}
                                        onChange={handleCreditsToTransferChange}
                                        className={"w-fill pt-1 px-2 pr-4"}
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' }, inputProps: { min: 1 } }}
                                        autoComplete='no'
                                    />
                                    <div className="min-h-3">
                                        {errors?.CreditAmount && (
                                            <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                                {errors?.CreditAmount}
                                            </FormHelperText>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex float-right mt-3 mb-3 mr-3">
                                <div className="ml-2"><ButtonComponent OnClick={handleClear} ButtonLabel={buttonLabels.CANCEL} Type="reset" ClassName={"px-3"} Variant={"secondary-btn-small"} /></div>
                                <div className="ml-2"><ButtonComponent Type="submit" ButtonLabel={buttonLabels.TRANSFER} Variant={"primary-btn-small"} ClassName={"mr-1"} /></div>
                            </div>
                        </div>
                    </form>
                </Grid>
                }
                {IsMobileDevice &&
                    <Grid container className={`bg-color-settings-background w-fill h-v-100 px-2`}>
                        <form onSubmit={openConfirmation} className={`d-flex flex-direction`}>
                            <div className={''}>
                                <div className={`bg-color-groupchat-avator-icon-bg`}>
                                    <div className='d-flex align-center pt-3' >
                                        <div className={`d-flex ml-4`} style={{ flex: 1 }}>
                                            <Typography className="h3-semibold color-settings-heading">
                                                {appNote.MANUAL_CREDIT_TRANSFER}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className="report-text color-conv-section-inactive pb-2 pt-1 px-4" >
                                        <div>Manually transfer credits between phone numbers as needed. Select the source, recipients, and the amount of credits to transfer.</div>
                                    </div>
                                </div>
                                <div className="border-top"></div>
                                <div>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pr-1 pl-4 pt-2'>Source Phone Number</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip enterTouchDelay={0} title={"Enter the phone number from which credits will be transferred."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 px-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers.filter(x => x.ID !== targetPhoneID && (x.Status === PhoneNumberStatus.ACTIVE)) || []}
                                        getOptionLabel={(option: PhoneNumberModel) => option.PhoneNumber ? `${UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} (${option.Name})` : ""}
                                        onChange={handleSourcePhoneChange}
                                        value={PhoneNumbers.find((x: PhoneNumberModel) => x.ID === sourcePhoneID) || { PhoneNumber: "", Name: "" } as PhoneNumberModel}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular color-primary-dark p-1 d-flex justify-between w-p-90"}>
                                                <div> {UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} ({option.Name})</div></li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="from" size="small" variant="outlined" placeholder="From *" />}
                                    />
                                    {!!creditType && sorucePhonePlanTracker && <FormHelperText className="h6-regular color-toaster-font t-align-right mr-4">
                                        {appNote.AVAILABLE} {creditTypeText} - <span className="h6-bold color-primary-light">{getSelectedCreditTypeCount(sorucePhonePlanTracker)}</span>
                                    </FormHelperText>}
                                    {errors?.SourcePhoneNumber && <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                        {errors?.SourcePhoneNumber}
                                    </FormHelperText>}
                                </div>
                                <div>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pl-4 pr-1 pt-2'>Recipient Phone Numbers</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip enterTouchDelay={0} title={"Enter one or more phone numbers to receive credits."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 px-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers.filter(x => x.ID !== sourcePhoneID && (x.Status === PhoneNumberStatus.ACTIVE)) || []}
                                        getOptionLabel={(option: PhoneNumberModel) => option.PhoneNumber ? `${UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} (${option.Name})` : ""}
                                        onChange={handleTargetPhoneChange}
                                        value={PhoneNumbers.find((x: PhoneNumberModel) => x.ID === targetPhoneID) || { PhoneNumber: "", Name: "" } as PhoneNumberModel}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular color-primary-dark p-1 d-flex justify-between w-p-90"}>
                                                <div> {UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)} ({option.Name})</div></li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="to" size="small" variant="outlined" placeholder="To *" />}
                                    />
                                    {!!creditType && targetPhonePlanTracker && <FormHelperText className="h6-regular color-toaster-font t-align-right mr-4">
                                        {appNote.AVAILABLE} {creditTypeText} - <span className="h6-bold color-primary-light">{getSelectedCreditTypeCount(targetPhonePlanTracker)}</span>
                                    </FormHelperText>}
                                    {errors?.TargetPhoneNumber && <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                        {errors?.TargetPhoneNumber}
                                    </FormHelperText>}
                                </div>
                                <div>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pl-4 pr-1 pt-2'>Credit Type</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip enterTouchDelay={0} title={"Specify the type of credits to transfer."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Autocomplete
                                        fullWidth
                                        className={"w-fill pt-1 px-4"}
                                        classes={{ input: 'color-text-field-font h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={creditOptions.filter((x: CreditOption) => x.Key === CreditType.ADDON_CREDITS_GROUP || x.Key === CreditType.ADDON_CREDITS_NORMAL)}
                                        getOptionLabel={(option: CreditOption) => option.Type}
                                        onChange={handleCreditTypeChange}
                                        value={creditOptions.find((x: CreditOption) => x.Key === creditType) || null}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h4-regular color-primary-dark p-1 d-flex justify-between w-p-90"}>
                                                <div> {option.Type}</div>
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="type" size="small" variant="outlined" placeholder="Credit Type *" />}
                                    />
                                    {errors?.CreditType && <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                        {errors?.CreditType}
                                    </FormHelperText>}
                                </div>
                                <div>
                                    <div className='d-flex'>
                                        <span className='h4-semibold color-settings-heading pl-4 pr-1 pt-2'>Credit Amount</span>
                                        <div className='d-flex align-center'>
                                            <Tooltip enterTouchDelay={0} title={"Specify the number of credits to transfer."} >
                                                <span style={{ marginTop: "16px" }}>
                                                    <NewInfoCircleIcon />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <TextField
                                        fullWidth
                                        name="CreditsToTransfer"
                                        placeholder="Credit Amount *"
                                        size="small"
                                        type="number"
                                        variant="outlined"
                                        value={creditsToTransfer}
                                        onChange={handleCreditsToTransferChange}
                                        className={"w-fill pt-1 px-4"}
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' }, inputProps: { min: 1 } }}
                                        autoComplete='no'
                                    />
                                    {errors?.CreditAmount && <FormHelperText className="h5 color-primary-danger t-align-right mr-4">
                                        {errors?.CreditAmount}
                                    </FormHelperText>}
                                </div>
                            </div>
                            <div className={`d-flex justify-between px-4 pt-4`} style={{ gap: '20px' }}>
                                <ButtonComponent
                                    buttonProps={{ tabIndex: 6 }}
                                    Variant={"secondary-btn"}
                                    OnClick={handleClear}
                                    ClassName={`c-pointer w-space w-fill justify-center mb-2 h2 `}
                                    Type="reset"
                                    ButtonLabel={buttonLabels.CANCEL}
                                />
                                <ButtonComponent
                                    buttonProps={{ tabIndex: 6 }}
                                    Variant="primary-btn"
                                    ClassName={`c-pointer w-space w-fill justify-center mb-2 h2`}
                                    Type={"submit"}
                                    ButtonLabel={buttonLabels.TRANSFER}
                                />
                            </div>
                        </form>
                    </Grid>
                }
            </>
            {
                showConfiramtion &&
                <ConfirmDialog
                    ButtonName={buttonLabels.TRANSFER}
                    onClose={closeConfirmDialog}
                    Show={showConfiramtion}
                    Text={appNote.TRANSFER_CONFIRMTAION_NOTE
                        .replace("<Amount>", creditsToTransfer.toString())
                        .replace("<Soruce_Phone_Name>", `${UtilityService.maskPhoneNumberOnLength(sourcePhoneNumber)} - ${sourcePhoneNumberName}`)
                        .replace("<Target_Phone_Name>", `${UtilityService.maskPhoneNumberOnLength(targetPhoneNumber)} - ${targetPhoneNumberName}`)}
                    Loading={showLoader}
                    IsMobileDevice={IsMobileDevice}
                ></ConfirmDialog>

            }
        </>
    )
}
export default TransferFormComponent;